"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var linkedin_svg_1 = __importDefault(require("../assets/linkedin.svg"));
var github_svg_1 = __importDefault(require("../assets/github.svg"));
function Footer() {
    return (react_1.default.createElement("footer", { className: "footer" },
        react_1.default.createElement("div", { className: 'footer--text-container' },
            react_1.default.createElement("p", { className: 'footer--creator' }, "Designed and developed by Skylar Kesselring"),
            react_1.default.createElement("p", null,
                "Illustration from ",
                react_1.default.createElement("a", { className: 'footer--link', href: "http://www.streamlinehq.com" }, "streamlinehq"))),
        react_1.default.createElement("a", { href: 'https://github.com/skylares', className: 'footer--shortcut', target: '_blank' },
            react_1.default.createElement("img", { src: github_svg_1.default, className: 'footer--shortcut-img' })),
        react_1.default.createElement("a", { href: 'https://www.linkedin.com/in/skylar-kesselring-178315b2/', className: 'footer--shortcut', target: '_blank' },
            react_1.default.createElement("img", { src: linkedin_svg_1.default, className: 'footer--shortcut-img' }))));
}
exports.default = Footer;
